import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

import { computed, onBeforeMount } from 'vue';
import SortItem from './SortItem.vue';
import { IRightSortConfig, IRightConfig } from '@common/core/interface/IModel';
import { useGlobalState } from '../../../store/carOwnerRight';
import { GetActivityRecord } from '../../../core/network/NodeAPI';
import { to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import dayjs from 'dayjs';

export default /*#__PURE__*/_defineComponent({
  __name: 'SortList',
  props: {
    sorts: null
  },
  setup(__props: any) {

const state = useGlobalState();
const { showModalError } = baseMixins();



const activityNoList = computed<string[]>(() =>
  (state.value.curRights as IRightConfig[]).reduce((prev, cur) => prev.concat(cur.activity || []), [] as string[]),
);

// 获取权益累计已领取数量
const getCurReceiveCount = async () => {
  if (!activityNoList.value.length) return;
  const [data, err] = await to(
    GetActivityRecord({
      activityNoList: activityNoList.value,
    }),
  );
  if (err) {
    showModalError(err.message, err.code);
    return;
  }
  state.value.allActivityNosRecord = data.list || {};
};

// 获取当月权益累计已领取数量
const getCurMonthReceiveCount = async () => {
  if (!activityNoList.value.length) return;
  const [data, err] = await to(
    GetActivityRecord({
      activityNoList: activityNoList.value,
      startTime: dayjs().startOf('month').valueOf(),
      endTime: dayjs().endOf('month').valueOf(),
    }),
  );
  if (err) {
    showModalError(err.message, err.code);
    return;
  }
  state.value.MonthActivityNosRecord = data.list || {};
};

onBeforeMount(() => {
  getCurReceiveCount();
  getCurMonthReceiveCount();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sorts, (sort) => {
    return (_openBlock(), _createBlock(SortItem, _mergeProps({
      key: sort.sortName,
      sort: sort
    }, _ctx.$attrs), null, 16, ["sort"]))
  }), 128))
}
}

})